import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { useI18n } from '../../../../i18n';

import { className } from '../../../lib/className';
import { sortByName } from '../../../lib/sorting';

import { actions as processorActions } from '../../../redux/api/processors';

import Input from '../../general/form/Input';
import List from '../../general/list/List';

import FlowProcessorListItem from './FlowProcessorListItem';

import './flowProcessorList.scss';

const actions = processorActions.flowProcessors;

/**
 * @param {Object} props
 * @param {number} props.selectedId
 * @param {function} props.onSelect
 * @param {function} props.onIntent
 */

function FlowProcessorList(props) {
	const { f } = useI18n();
	const [filter, setFilter] = useState('');
	const processors = props.processors ? props.processors.list : [];

	useEffect(() => {
		if (processors == null) props.dispatch(actions.load.request());
	}, []);

	const getProcessors = () => {
		return filter
			? processors.filter(processor => processor.name.toLowerCase().includes(filter.toLowerCase()))
			: processors
		;
	}

	let content = null;
	if (processors != null) {
		const items = sortByName(getProcessors()).map(processor =>
			<FlowProcessorListItem
				className={className({ 'selected': (props.selectedId && props.selectedId == processor.processorId) })}
				key={processor.processorId}
				processor={processor}
				onSelect={props.onSelect}
				onIntent={props.onIntent}
			/>
		);
		content = (<List>{items}</List>);
	}

	return (<>
		<div className="filter">
			<Input label={f('filter')} value={filter} onChange={setFilter} cleanable />
		</div>
		<div className="flow-processor-list">
			<label>
				{f('flow processors')}
			</label>
			{content}
		</div>
	</>);
}

export default connect(
	state => ({
		processors: state.processors.flowProcessors
	})
)(FlowProcessorList);
